<template>
        <ion-page>
            <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>My Service Requisitions</ion-title>
            </ion-toolbar>
            </ion-header>
            
            <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                <ion-title size="large">My Service Requisitions</ion-title>
                </ion-toolbar>
            </ion-header>
            
            <div id="container">
                <DataTable :loading="loading" class="p-datatable-sm"  :value="requisitions" :lazy="true" :paginator="true" :rows="perPage" :totalRecords="total"  @page="onPage($event)" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                    <template #loading>
                        Loading data, please wait...
                    </template>
                    <template #empty>
                        No records found
                    </template>
                    <Column field="serial" header="#"></Column>
                    <Column field="company" header="Company"></Column>
                    <Column field="shipName" header="Ship"></Column>
                    <Column field="port" header="Port"></Column>
                    <Column field="sarviceDate" header="Service at"></Column>
                    <Column field="problem" header="Problem"></Column>
                    <Column field="contact" header="Contact Person"></Column>
                    <Column field="assignedTo" header="Assigned To"></Column>
                    <Column field="status" header="Service Status"></Column>
                    <Column field="billing" header="Billing"></Column>
                    <!-- <Column field="updatedBy" header="Updated By">
                        <template #body="{data}">
                            <div v-html="data.details"></div>
                        </template>
                    </Column> -->
                </DataTable>
            </div>
            </ion-content>
        </ion-page>
</template>

<script >
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/vue';
import { defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default defineComponent({
  name: 'My Requisition Requests',
  data(){
      return {
          requisitions:[],
          loading:false,
          perPage:10,
          total:0,
      }
  },
  mounted(){
      this.loadData(0);
  },
  methods:{
      async loadData(page){
          const data={
              'page':page + 1,
              'username':window.localStorage.username,
              'password':window.localStorage.password,
          };
          this.loading=true;
        this.$http.get('get_service_requisitions',{params:data}).then(response=>{
            // const rows=[];
            this.perPage=response.data.perPage;
            this.total=response.data.total;
            let serial= (page * this.perPage) + 1;
            this.requisitions=[];
            for(const req of response.data.data){
                this.requisitions.push({
                    serial: serial++,
                    company:req.ship.owner.company.company_name,
                    client:req.ship.owner.client_name + ' (' + req.ship.owner.mobile + ')',
                    shipName:req.ship.ship_name ,
                    port:req.port,
                    sarviceDate:req.service_date_time,
                    problem: req.problem,
                    contact: req.contact_person  + ' (' + req.contact_number + ')',
                    assignedTo:req.assignedTo ,
                    status:req.status,
                    billing:req.billing,
                    // createdBy:req.created,
                    // updatedBy:req.updated
                    // details:'Client:' + req.ship.owner.client_name + ' (' + req.ship.owner.mobile + ')' 
                    //  + '<br> Ship Name:' + req.ship.ship_name 
                    //  + '<br> Service Port:' + req.port.port_name 
                    //  + '<br> Service Date Time:' + req.service_date_time 
                    //  + '<br> Problem:' + req.problem
                    //  + '<br> Contact:' + req.contact_person  + ' (' + req.contact_number + ')' 
                    //  + '<br> Assigned To:' + req.assignedTo 
                    //  + '<br> Status:' + req.status
                    //  + '<br>Created By:' + req.created_by 
                    //  + '<br> Updated By:' + req.updated_by,
                });
            }
            this.loading=false;
        });

      },
      onPage(event){
          this.loadData(event.page);
      }
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    DataTable,
    Column
  }
});
</script>

<style scoped>
.dataRow:nth-child(even){
    background-color: #f2f2f2 !important;
}
</style>